export enum Permission {
  ManageUsers = 'manage_users.legacy_permission',
  ModifyRoles = 'role_management.modify',
}
